<template>
  <div class="sched_wrap">
    <div class="toolbar">
      <el-form :inline="true" :model="queryForm" class="query_form" @submit.native.prevent>
        <el-form-item label="数字员工">
          <el-select v-model="queryForm.agent_id" placeholder="全部" clearable filterable style="width: 180px">
            <el-option v-for="a in agentOptions" :key="a.agent_id"
                       :label="a.display_name || a.name" :value="a.agent_id" />
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="queryForm.status" placeholder="全部" clearable style="width: 120px">
            <el-option label="启用" value="active" />
            <el-option label="已暂停" value="paused" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>
      <div>
        <el-button icon="el-icon-magic-stick" @click="openDetect">自然语言建任务</el-button>
        <el-button type="primary" icon="el-icon-plus" @click="openAdd">新建任务</el-button>
      </div>
    </div>

    <el-table :data="tableData" v-loading="loading" border>
      <el-table-column prop="name" label="任务名称" min-width="140" show-overflow-tooltip />
      <el-table-column label="数字员工" min-width="120" show-overflow-tooltip>
        <template slot-scope="scope">{{ agentName(scope.row.agent_id) }}</template>
      </el-table-column>
      <el-table-column label="执行规则" min-width="180" show-overflow-tooltip>
        <template slot-scope="scope">{{ ruleText(scope.row.rule) }}</template>
      </el-table-column>
      <el-table-column label="状态" width="90">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status === 'active' ? 'success' : 'info'" size="small">
            {{ scope.row.status === 'active' ? '启用' : '已暂停' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="上次执行" width="160">
        <template slot-scope="scope">{{ fmtTime(scope.row.last_run_at) }}</template>
      </el-table-column>
      <el-table-column label="下次执行" width="160">
        <template slot-scope="scope">{{ fmtTime(scope.row.next_run_at) }}</template>
      </el-table-column>
      <el-table-column prop="run_count" label="执行次数" width="90" />
      <el-table-column label="操作" width="240" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="openEdit(scope.row)">编辑</el-button>
          <el-button type="text" size="small" @click="handleStatus(scope.row)">
            {{ scope.row.status === 'active' ? '暂停' : '启用' }}
          </el-button>
          <el-button type="text" size="small" @click="openRuns(scope.row)">执行记录</el-button>
          <el-button type="text" size="small" class="danger_text" @click="handleDel(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pagesize"
      background
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    />

    <!-- 新建/编辑任务弹窗 -->
    <el-dialog :title="isEdit ? '编辑任务' : '新建任务'" :visible.sync="dialogVisible"
               width="620px" v-dialogDrag :modal-append-to-body="false" v-if="dialogVisible">
      <el-alert v-if="needConfirm" type="warning" :closable="false" show-icon class="need_confirm_alert"
                title="模型生成的规则不合法，请检查并修正后提交" />
      <el-form ref="form" :model="form" :rules="rules" label-width="90px" @submit.native.prevent>
        <el-form-item label="数字员工" prop="agent_id">
          <el-select v-if="!isEdit" v-model="form.agent_id" filterable placeholder="请选择数字员工" style="width: 100%">
            <el-option v-for="a in agentOptions" :key="a.agent_id"
                       :label="a.display_name || a.name" :value="a.agent_id" />
          </el-select>
          <!-- 任务不可改绑员工，编辑时仅展示 -->
          <el-input v-else :value="form.agentName" disabled />
        </el-form-item>
        <el-form-item label="任务名称" prop="name">
          <el-input v-model="form.name" maxlength="64" placeholder="请输入任务名称" />
        </el-form-item>
        <el-form-item label="任务指令" prop="prompt">
          <el-input v-model="form.prompt" type="textarea" :rows="4" maxlength="2000"
                    placeholder="每次触发时发给数字员工的指令" />
        </el-form-item>
        <el-form-item label="执行频率">
          <el-radio-group v-model="form.rule.freq">
            <el-radio label="daily">每天</el-radio>
            <el-radio label="weekly">每周</el-radio>
            <el-radio label="monthly">每月</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="执行间隔">
          <el-input-number v-model="form.rule.interval" :min="1" :max="999" />
          <span class="form_tip">每 {{ form.rule.interval }} {{ freqUnit }}一次</span>
        </el-form-item>
        <el-form-item v-if="form.rule.freq === 'weekly'" label="指定星期" prop="rule.by_days">
          <el-checkbox-group v-model="form.rule.by_days">
            <el-checkbox v-for="(label, key) in WEEK_DAYS" :key="key" :label="key">{{ label }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item v-if="form.rule.freq === 'monthly'" label="指定日期" prop="rule.by_month_days">
          <el-select v-model="form.rule.by_month_days" multiple filterable placeholder="选择每月几号" style="width: 100%">
            <el-option v-for="d in 31" :key="d" :label="d + ' 日'" :value="d" />
          </el-select>
        </el-form-item>
        <el-form-item label="执行时间" prop="rule.at">
          <el-time-picker v-model="form.rule.at" format="HH:mm" value-format="HH:mm" placeholder="选择时间" />
        </el-form-item>
        <el-form-item label="时区">
          <el-input v-model="form.timezone" maxlength="64" placeholder="IANA 时区名" style="width: 220px" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="submiting" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 自然语言建任务弹窗 -->
    <el-dialog title="自然语言建任务" :visible.sync="detectVisible"
               width="560px" v-dialogDrag :modal-append-to-body="false" v-if="detectVisible">
      <el-form label-width="90px" @submit.native.prevent>
        <el-form-item label="数字员工">
          <el-select v-model="detectForm.agent_id" filterable placeholder="请选择数字员工" style="width: 100%">
            <el-option v-for="a in agentOptions" :key="a.agent_id"
                       :label="a.display_name || a.name" :value="a.agent_id" />
          </el-select>
        </el-form-item>
        <el-form-item label="任务描述">
          <el-input v-model="nlInput" type="textarea" :rows="4" maxlength="500"
                    placeholder="例：每个工作日早上 9 点汇总昨日销售数据" />
        </el-form-item>
      </el-form>
      <div class="detect_tip">由模型生成任务草稿（最长约 90 秒），生成后可在表单中修正再保存</div>
      <div slot="footer">
        <el-button @click="detectVisible = false">取 消</el-button>
        <el-button type="primary" :loading="detecting" @click="runDetect">生成草稿</el-button>
      </div>
    </el-dialog>

    <!-- 执行记录弹窗 -->
    <el-dialog :title="'执行记录 - ' + (runsTask ? runsTask.name : '')" :visible.sync="runsVisible"
               width="920px" v-dialogDrag :modal-append-to-body="false" v-if="runsVisible">
      <el-table :data="runsData" v-loading="runsLoading" border>
        <el-table-column label="状态" width="90">
          <template slot-scope="scope">
            <el-tag :type="(RUN_STATUS[scope.row.status] || {}).tag || 'info'" size="small">
              {{ (RUN_STATUS[scope.row.status] || {}).text || scope.row.status || '-' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="触发时间" width="160">
          <template slot-scope="scope">{{ fmtTime(scope.row.triggered_at) }}</template>
        </el-table-column>
        <el-table-column label="完成时间" width="160">
          <template slot-scope="scope">{{ fmtTime(scope.row.done_at) }}</template>
        </el-table-column>
        <el-table-column label="补跑" width="60">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.misfire" type="warning" size="mini">补跑</el-tag>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="回复 / 错误" min-width="220">
          <template slot-scope="scope">
            <span v-if="scope.row.status === 'failed'" class="danger_text run_error"
                  :title="scope.row.error">{{ scope.row.error || '-' }}</span>
            <el-button v-else-if="scope.row.reply" type="text" size="small" @click="showReply(scope.row)">查看回复</el-button>
            <span v-else>-</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="runsSizeChange"
        @current-change="runsPageChange"
        :current-page="runsPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="runsSize"
        background
        layout="total, sizes, prev, pager, next"
        :total="runsTotal"
      />
    </el-dialog>

    <!-- 执行回复详情弹窗 -->
    <el-dialog title="执行回复" :visible.sync="replyVisible"
               width="640px" v-dialogDrag :modal-append-to-body="false" v-if="replyVisible">
      <pre class="pre_text">{{ replyText }}</pre>
    </el-dialog>
  </div>
</template>

<script>
import { agentBody, isEnterprise } from '../utils'

// 星期映射（by_days 合法值，与后端约定 mon~sun）
const WEEK_DAYS = { mon: '周一', tue: '周二', wed: '周三', thu: '周四', fri: '周五', sat: '周六', sun: '周日' }
// 执行记录状态
const RUN_STATUS = {
  running: { text: '运行中', tag: 'warning' },
  done: { text: '已完成', tag: 'success' },
  failed: { text: '失败', tag: 'danger' },
  missed: { text: '未执行', tag: 'info' }
}

// 定时任务管理：结构化规则（非 cron）任务 CRUD、启停、执行记录、自然语言生成草稿
export default {
  name: 'AiAgentScheduled',
  data() {
    // at 须严格 HH:mm（24h 制，服务端正则同校验）
    const validAt = (rule, value, cb) => {
      if (!value) return cb(new Error('请选择执行时间'))
      if (!/^([01]\d|2[0-3]):[0-5]\d$/.test(value)) return cb(new Error('时间格式须为 HH:mm'))
      cb()
    }
    const validByDays = (rule, value, cb) => {
      if (this.form.rule.freq === 'weekly' && !(value || []).length) return cb(new Error('每周任务须至少选择一个星期'))
      cb()
    }
    const validByMonthDays = (rule, value, cb) => {
      if (this.form.rule.freq === 'monthly' && !(value || []).length) return cb(new Error('每月任务须至少选择一个日期'))
      cb()
    }
    return {
      WEEK_DAYS,
      RUN_STATUS,
      queryForm: { agent_id: '', status: '' },
      agentOptions: [],
      tableData: [],
      loading: false,
      currentPage: 1,
      pagesize: 20,
      total: 0,
      reqSeq: 0,
      dialogVisible: false,
      isEdit: false,
      submiting: false,
      needConfirm: false, // detect 草稿规则不合法时警示
      form: this.emptyForm(),
      rules: {
        agent_id: [{ required: true, message: '请选择数字员工', trigger: 'change' }],
        name: [{ required: true, message: '请输入任务名称', trigger: 'blur' }],
        prompt: [{ required: true, message: '请输入任务指令', trigger: 'blur' }],
        'rule.at': [{ required: true, validator: validAt, trigger: 'change' }],
        'rule.by_days': [{ validator: validByDays, trigger: 'change' }],
        'rule.by_month_days': [{ validator: validByMonthDays, trigger: 'change' }]
      },
      detectVisible: false,
      detecting: false,
      nlInput: '',
      detectForm: { agent_id: '' },
      runsVisible: false,
      runsLoading: false,
      runsTask: null,
      runsData: [],
      runsPage: 1,
      runsSize: 10,
      runsTotal: 0,
      runsSeq: 0,
      replyVisible: false,
      replyText: ''
    }
  },
  computed: {
    freqUnit() {
      return { daily: '天', weekly: '周', monthly: '月' }[this.form.rule.freq] || ''
    }
  },
  watch: {
    // 切频率时清掉另一套选择，避免残留误提交
    'form.rule.freq'(val) {
      if (val !== 'weekly') this.form.rule.by_days = []
      if (val !== 'monthly') this.form.rule.by_month_days = []
      if (this.$refs.form) this.$refs.form.clearValidate(['rule.by_days', 'rule.by_month_days'])
    }
  },
  mounted() {
    // Tab 仅企业可见；平台账号常驻挂载下发 owner 型请求会 1002 弹错，跳过自动加载
    if (!isEnterprise()) return
    this.loadAgents()
    this.loadTasks()
  },
  methods: {
    emptyForm() {
      return {
        task_id: '',
        agent_id: '',
        agentName: '',
        name: '',
        prompt: '',
        timezone: 'Asia/Shanghai',
        rule: this.emptyRule()
      }
    },
    emptyRule() {
      return { freq: 'daily', interval: 1, by_days: [], by_month_days: [], at: '09:00' }
    },
    loadAgents() {
      return this.$tools.asyncPost(this, this.$baseUrl.aiAgentAgentsList,
        agentBody({ page: 1, limit: 0 })).then((res) => {
        if (res.data.code == 0) this.agentOptions = res.data.data.data || []
      }).catch(() => {})
    },
    agentName(id) {
      const a = this.agentOptions.find(x => x.agent_id === id)
      return a ? (a.display_name || a.name) : (id || '-')
    },
    // ===== 任务列表 =====
    loadTasks() {
      this.loading = true
      const data = { page: this.currentPage, limit: this.pagesize }
      if (this.queryForm.agent_id) data.agent_id = this.queryForm.agent_id
      if (this.queryForm.status) data.status = this.queryForm.status
      const seq = ++this.reqSeq
      this.$tools.asyncPost(this, this.$baseUrl.aiAgentSchedTasksList, agentBody(data)).then((res) => {
        if (seq !== this.reqSeq) return
        if (res.data.code == 0) {
          this.tableData = res.data.data.data || []
          this.total = res.data.data.total || 0
        }
        this.loading = false
      }).catch((err) => {
        // 与 memory.loadList 同口径：网络层失败给提示；业务错已由拦截器弹出
        if (err && err.isAxiosError) this.$message({ type: 'error', message: err.response ? '请求失败，请稍后重试' : '网络异常，请稍后重试' })
        if (seq === this.reqSeq) this.loading = false
      })
    },
    onSearch() {
      this.currentPage = 1
      this.loadTasks()
    },
    resetQuery() {
      this.queryForm = { agent_id: '', status: '' }
      this.onSearch()
    },
    handleSizeChange(val) { this.pagesize = val; this.currentPage = 1; this.loadTasks() },
    handleCurrentChange(val) { this.currentPage = val; this.loadTasks() },

    // ===== 新建/编辑 =====
    openAdd() {
      this.loadAgents() // 下拉可能因 agents Tab 增删而过期，打开时刷新
      this.form = this.emptyForm()
      this.needConfirm = false
      this.isEdit = false
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
    },
    openEdit(row) {
      this.$tools.asyncPost(this, this.$baseUrl.aiAgentSchedTasksGet,
        agentBody({ task_id: row.task_id })).then((res) => {
        const d = res.data.data || {}
        this.form = {
          task_id: d.task_id || row.task_id,
          agent_id: d.agent_id || row.agent_id,
          agentName: this.agentName(d.agent_id || row.agent_id),
          name: d.name || '',
          prompt: d.prompt || '',
          timezone: d.timezone || 'Asia/Shanghai',
          rule: Object.assign(this.emptyRule(), d.rule || {})
        }
        this.needConfirm = false
        this.isEdit = true
        this.dialogVisible = true
        this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
      }).catch((err) => {
        if (err && err.isAxiosError) this.$message({ type: 'error', message: err.response ? '请求失败，请稍后重试' : '网络异常，请稍后重试' })
      })
    },
    // 仅按当前 freq 提交对应选择，daily 不带 by_*（服务端会按 freq 校验必填）
    buildRule() {
      const r = this.form.rule
      return {
        freq: r.freq,
        interval: r.interval,
        at: r.at,
        by_days: r.freq === 'weekly' ? r.by_days : [],
        by_month_days: r.freq === 'monthly' ? r.by_month_days : []
      }
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (!valid) return
        this.submiting = true
        // edit 请求体无 agent_id（任务不可改绑员工）
        const payload = {
          name: this.form.name,
          prompt: this.form.prompt,
          rule: this.buildRule(),
          timezone: this.form.timezone
        }
        if (this.isEdit) payload.task_id = this.form.task_id
        else payload.agent_id = this.form.agent_id
        const url = this.isEdit ? this.$baseUrl.aiAgentSchedTasksEdit : this.$baseUrl.aiAgentSchedTasksAdd
        this.$tools.asyncPost(this, url, agentBody(payload)).then((res) => {
          if (res.data.code == 0) {
            this.$message({ type: 'success', message: res.data.msg || '保存成功' })
            this.dialogVisible = false
            if (!this.isEdit) this.currentPage = 1
            this.loadTasks()
          }
          this.submiting = false
        }).catch((err) => {
          this.submiting = false
          if (err && err.isAxiosError) this.$message({ type: 'error', message: err.response ? '请求失败，请稍后重试' : '网络异常，请稍后重试' })
        })
      })
    },

    // ===== 启停 / 删除 =====
    handleStatus(row) {
      const action = row.status === 'active' ? 'pause' : 'resume'
      const verb = action === 'pause' ? '暂停' : '启用'
      this.$tools.asyncPost(this, this.$baseUrl.aiAgentSchedTasksStatus,
        agentBody({ task_id: row.task_id, action })).then((res) => {
        // resume 时 next_run_at 已过期会自动重算，后端 msg 为"已启用"
        if (res.data.code == 0) {
          this.$message({ type: 'success', message: res.data.msg || (verb + '成功') })
          this.loadTasks()
        }
      }).catch((err) => {
        if (err && err.isAxiosError) this.$message({ type: 'error', message: err.response ? '请求失败，请稍后重试' : '网络异常，请稍后重试' })
      })
    },
    handleDel(row) {
      this.$MessageBox.confirm('删除后任务停止执行且不可恢复，确认删除该任务？', '提示', { type: 'warning' }).then(() => {
        this.$tools.asyncPost(this, this.$baseUrl.aiAgentSchedTasksDel,
          agentBody({ task_id: row.task_id })).then((res) => {
          if (res.data.code == 0) {
            this.$message({ type: 'success', message: '删除成功' })
            if (this.tableData.length === 1 && this.currentPage > 1) this.currentPage -= 1
            this.loadTasks()
          }
        }).catch((err) => {
          if (err && err.isAxiosError) this.$message({ type: 'error', message: err.response ? '请求失败，请稍后重试' : '网络异常，请稍后重试' })
        })
      }).catch(() => {})
    },

    // ===== 自然语言建任务 =====
    openDetect() {
      this.loadAgents()
      this.detectForm = { agent_id: this.queryForm.agent_id || '' }
      this.nlInput = ''
      this.detectVisible = true
    },
    runDetect() {
      if (!this.detectForm.agent_id) return this.$message({ type: 'warning', message: '请先选择数字员工' })
      if (!this.nlInput || !this.nlInput.trim()) return this.$message({ type: 'warning', message: '请输入任务描述' })
      this.detecting = true
      this.$tools.asyncPost(this, this.$baseUrl.aiAgentSchedTasksDetect,
        agentBody({ agent_id: this.detectForm.agent_id, text: this.nlInput.trim() })).then((res) => {
        const d = res.data.data || {}
        // 草稿与 add 请求体同构，直接回填新建表单让用户核对修正
        const rule = Object.assign(this.emptyRule(), d.rule || {})
        // by_* 无条件归一化（幂等）：后端 ToLower 容忍的大小写/重复/越界值会在 checkbox 中不可见选中且无法移除
        rule.by_days = [...new Set((rule.by_days || []).map(d => String(d).toLowerCase()).filter(d => Object.prototype.hasOwnProperty.call(WEEK_DAYS, d)))]
        rule.by_month_days = [...new Set((rule.by_month_days || []).map(n => Number(n)).filter(n => Number.isInteger(n) && n >= 1 && n <= 31))]
        this.needConfirm = !!d.need_confirm
        if (this.needConfirm) {
          if (!/^([01]\d|2[0-3]):[0-5]\d$/.test(rule.at || '')) rule.at = ''
          if (!Number.isInteger(rule.interval) || rule.interval < 1 || rule.interval > 999) rule.interval = 1
        }
        this.form = {
          task_id: '',
          agent_id: this.detectForm.agent_id,
          agentName: this.agentName(this.detectForm.agent_id),
          name: d.name || '',
          prompt: d.prompt || '',
          timezone: d.timezone || 'Asia/Shanghai',
          rule
        }
        this.isEdit = false
        this.detectVisible = false
        this.dialogVisible = true
        this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
        this.detecting = false
      }).catch((err) => {
        this.detecting = false
        if (err && err.isAxiosError) this.$message({ type: 'error', message: err.response ? '请求失败，请稍后重试' : '网络异常，生成草稿失败，请稍后重试' })
      })
    },

    // ===== 执行记录 =====
    openRuns(row) {
      this.runsTask = row
      this.runsPage = 1
      this.runsVisible = true
      this.loadRuns()
    },
    loadRuns() {
      if (!this.runsTask) return
      this.runsLoading = true
      const seq = ++this.runsSeq
      this.$tools.asyncPost(this, this.$baseUrl.aiAgentSchedTasksRuns,
        agentBody({ task_id: this.runsTask.task_id, page: this.runsPage, limit: this.runsSize })).then((res) => {
        if (seq !== this.runsSeq) return
        if (res.data.code == 0) {
          this.runsData = res.data.data.data || []
          this.runsTotal = res.data.data.total || 0
        }
        this.runsLoading = false
      }).catch((err) => {
        if (err && err.isAxiosError) this.$message({ type: 'error', message: err.response ? '请求失败，请稍后重试' : '网络异常，请稍后重试' })
        if (seq === this.runsSeq) this.runsLoading = false
      })
    },
    runsSizeChange(val) { this.runsSize = val; this.runsPage = 1; this.loadRuns() },
    runsPageChange(val) { this.runsPage = val; this.loadRuns() },
    showReply(row) {
      this.replyText = row.reply || ''
      this.replyVisible = true
    },

    // 主入口切 Tab 激活时刷新
    onActivate() {
      this.loadAgents()
      this.loadTasks()
    },

    // ===== 展示工具 =====
    ruleText(rule) {
      if (!rule || !rule.freq) return '-'
      const base = { daily: '每天', weekly: '每周', monthly: '每月' }[rule.freq] || rule.freq
      const unit = { daily: '天', weekly: '周', monthly: '月' }[rule.freq]
      const detail = []
      if (rule.interval > 1) detail.push(`每 ${rule.interval}${unit}`)
      if (rule.freq === 'weekly' && (rule.by_days || []).length) {
        detail.push((rule.by_days || []).map(d => WEEK_DAYS[d] || d).join('、'))
      }
      if (rule.freq === 'monthly' && (rule.by_month_days || []).length) {
        detail.push((rule.by_month_days || []).map(d => d + '日').join('、'))
      }
      return `${base}${detail.length ? '（' + detail.join(' ') + '）' : ''} ${rule.at || ''}`
    },
    fmtTime(s) {
      // 未执行过时后端返回 Go 零值时间（0001-01-01T00:00:00Z），按空处理
      if (!s || String(s).indexOf('0001-01-01') === 0) return '-'
      const t = this.$tools.parserDateTime('datetime', s)
      // parserDateTime 对非法输入返回 NaN 串恒非空，回退原文截断
      if (t && t.indexOf('NaN') < 0) return t
      return String(s).substring(0, 19).replace('T', ' ')
    }
  }
}
</script>

<style lang="less" scoped>
.toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  // 表单下边距改由 toolbar 承担，保证表格前的间距不变
  margin-bottom: 22px;
  .query_form {
    /deep/ .el-form-item {
      margin-bottom: 0;
    }
  }
}
.danger_text {
  color: #f56c6c;
}
.need_confirm_alert {
  margin-bottom: 12px;
}
.form_tip {
  margin-left: 8px;
  color: #909399;
  font-size: 12px;
}
.detect_tip {
  padding: 0 90px;
  color: #909399;
  font-size: 12px;
}
.run_error {
  font-size: 12px;
}
.pre_text {
  margin: 0;
  max-height: 400px;
  overflow: auto;
  font-size: 13px;
  line-height: 1.6;
  white-space: pre-wrap;
  word-break: break-all;
}
</style>
